import React from "react";
import { motion } from "framer-motion";
import { Database, LineChart, Scale, GitCompareArrows, LayoutDashboard } from "lucide-react";

const ICONS = [Database, LineChart, Scale, GitCompareArrows, LayoutDashboard];
const SUB = [
  "yfinance weekly bars",
  "RSI · StochRSI · MACD · ADX · BB",
  "P/E · ROE · PEG · quality",
  "dual confirmation",
  "live dashboard output",
];

export default function Pipeline({ stages = [], running, processed = 0, total = 0, matches = 0, current }) {
  const activeIdx = running ? Math.min(4, Math.floor((processed / Math.max(total, 1)) * 4.9)) : -1;
  return (
    <div className="bg-white border border-[#E2E8F0] rounded-[4px] shadow-xs p-3.5" data-testid="agentic-pipeline">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <span className="font-bold text-[13px] tracking-[0.12em] uppercase text-slate-700">Agentic Pipeline</span>
          <span className="font-mono text-[11px] text-slate-400">5 NODES</span>
        </div>
        <div className="font-mono text-[12px] text-slate-500 tabular-nums">
          {running ? (
            <span className="text-[#0284C7] font-semibold">RUNNING · {processed}/{total} · {current || "…"}</span>
          ) : (
            <span>IDLE · {matches} matched last run</span>
          )}
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2.5">
        {stages.map((s, i) => {
          const Icon = ICONS[i];
          const active = i === activeIdx;
          const done = running && i < activeIdx;
          return (
            <div key={s} className="relative">
              <motion.div
                animate={active ? { scale: [1, 1.01, 1] } : {}}
                transition={{ duration: 1, repeat: active ? Infinity : 0 }}
                className={`h-full rounded-[3px] border p-3 transition-colors duration-200 ${
                  active ? "bg-[#F0F9FF] border-[#0284C7]" : done ? "bg-[#F0FDF4] border-[#86EFAC]" : "bg-white border-[#E2E8F0]"
                }`}
                data-testid={`pipeline-node-${i}`}
              >
                <div className="flex items-center gap-2 mb-2">
                  <div className="relative">
                    <Icon size={15} className={active ? "text-[#0284C7]" : done ? "text-[#00873C]" : "text-slate-400"} />
                    {active && <span className="status-ping absolute -top-0.5 -right-0.5 w-1.5 h-1.5 rounded-full text-[#0284C7]" />}
                  </div>
                  <span className="font-mono text-[11px] text-slate-400">0{i + 1}</span>
                </div>
                <div className="font-display text-[13px] font-semibold text-slate-800 leading-tight">{s}</div>
                <div className="font-mono text-[11px] text-slate-400 mt-1 leading-tight">{SUB[i]}</div>
              </motion.div>
              {active && <div className="absolute -bottom-2 left-0 right-0 h-[2px] flow-line rounded-full lg:block hidden" />}
            </div>
          );
        })}
      </div>
    </div>
  );
}
